<fin-expand
  class="block rounded"
  [ngClass]="{ 'white-bg': isOpen$ | async }"
  [initiallyOpen]="initiallyOpen"
  [key]="expandId"
  [id]="expandId"
>
  <div
    class="trigger flex flex--center"
    [ngClass]="{
      'pr-xsmall-x ps-xsmall-y': (isOpen$ | async) === false,
      'pr-small-t pr-small-x': isOpen$ | async
    }"
    [attr.aria-label]="expandButtonAriaLabelKey | finLocalization"
  >
    <div *ngIf="(isOpen$ | async) === false" class="flex expand-closed">
      <span class="flex-1 gray-50-text ps-xxsmall-r" data-test-total-translation
        >{{ totalTranslationKey$ | async | finLocalization }}:</span
      >
      <span class="flex-1 medium-type" data-test-total-price
        >{{ total$ | async | finPrice: false : true : true }}
        <fcom-icon
          *ngIf="(loading$ | async) === true"
          class="ms-xxsmall-l ir-xsmall"
          name="transfer-loader"
          category="svg-library"
          [attr.aria-label]="'ctaButton.loading' | finLocalization"
        ></fcom-icon>
      </span>
    </div>
    <div
      data-test-title
      class="bold flex flex-1"
      [ngClass]="{
        'font-heading-4 nordic-blue-900-text': isOpen$ | async,
        'underline medium-type flex--end': (isOpen$ | async) === false
      }"
    >
      <div class="flex flex--center" [ngClass]="{ fill: isOpen$ | async }">
        <div class="flex-1 pr-xxsmall-r">{{ titleTranslationKey | finLocalization }}</div>
        <fcom-icon
          name="chevron-down"
          class="rotate ir-xsmall"
          [ngClass]="{ 'nordic-blue-900-text rotate-active': isOpen$ | async }"
        ></fcom-icon>
      </div>
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</fin-expand>
